/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_Undo_UnavailableInputs */



/**
* | output |
* | --- |
* | "Newer changes exist. Use Edit > Undo to step back to this one." |
*
* @param {Assistant_Activity_Undo_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_undo_unavailable = /** @type {((inputs?: Assistant_Activity_Undo_UnavailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Undo_UnavailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Des modifications plus récentes existent. Utilisez Édition > Annuler pour revenir à la version précédente.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es gibt neuere Änderungen. Verwenden Sie Bearbeiten > Rückgängig, um zu dieser Version zurückzukehren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sono presenti modifiche più recenti. Utilizza Modifica > Annulla per tornare alla versione precedente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Существуют более новые изменения. Используйте «Редактировать» > «Отменить», чтобы вернуться к предыдущему состоянию.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Existen cambios más recientes. Utilice Editar > Deshacer para volver a esta versión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已有更新的更改。使用“编辑”>“撤销”可返回到此更改。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい変更が存在します。編集＞元に戻すを選択して、この変更に戻してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुछ नए बदलाव मौजूद हैं। इस बदलाव पर वापस जाने के लिए एडिट > अनडू का इस्तेमाल करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Existem alterações mais recentes. Use Editar > Desfazer para reverter para esta versão.")
	return /** @type {LocalizedString} */ ("Newer changes exist. Use Edit > Undo to step back to this one.")
});